import { convertToDate } from './date-helper';

export const formatPassengerCards = (
  passengerCards: PassengerDeclaration[],
): PassengerDeclaration[] => {
  return passengerCards.map((passenger: PassengerDeclaration) => {
    const passengerCompanion = passenger?.passengerCompanion?.map(
      (companion) => {
        return {
          ...companion,
          dateOfBirth: convertToDate(companion.dateOfBirth),
        };
      },
    );
    return {
      ...passenger,
      dateOfArrival: convertToDate(passenger.dateOfArrival),
      dateOfBirth: convertToDate(passenger.dateOfBirth),
      passengerCompanion: passengerCompanion?.length ? passengerCompanion : [],
    };
  });
};
